import React, { FC, useContext } from 'react'
import { GlobalContext, SAVE_SESSION_DATA } from '@store'
import { DarkBackground } from '@css/darkBackground'
import { HomepageContent } from './Content'
import { Props } from './index'

export const Homepage: FC<Props> = (props) => {
  const { state, dispatch } = useContext(GlobalContext)

  function onSave(key, val) {
    dispatch({ type: SAVE_SESSION_DATA, key: key, value: val })
  }

  return (
    <div>
      <DarkBackground />
      <HomepageContent
        {...state}
        {...props}
        onSaveSessionData={onSave}
      />
    </div>
  )
}
